import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "src/app/shared/services/base.http.service";
import { QuestionAndAnswer, QuestionAndAnswerToAdd } from "../model/qna.model";

@Injectable({
  providedIn: "root",
})
export class QnAService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  getSignleQuestion(id: number) {
    return this.http.get<QuestionAndAnswer>(`${this.apiUrl}/api/QnA/${id}`);
  }

  getQuestions() {
    return this.http.get<QuestionAndAnswer[]>(`${this.apiUrl}/api/QnA`);
  }

  createQuestion(data: QuestionAndAnswerToAdd) {
    return this.http.post(`${this.apiUrl}/api/QnA`, data);
  }

  updateOrder(questions: QuestionAndAnswer[]) {
    return this.http.put(`${this.apiUrl}/api/QnA/order`, { questions });
  }

  updateQuestion(id: number, data: QuestionAndAnswerToAdd) {
    return this.http.put(`${this.apiUrl}/api/QnA/${id}`, data);
  }

  deleteQuestion(id: number) {
    return this.http.delete(`${this.apiUrl}/api/QnA/${id}`);
  }
}
